import Vue from "vue"
import * as VueGoogleMaps from 'vue2-google-maps';

export default (apiKey) => {
  Vue.use(VueGoogleMaps, {
    load: {
        key: apiKey,
    },
    installComponents: true
  })
}
